import React from "react";
import CustomInput from "components/CustomInput";

export default function Step6DateIdentificareCetateanRoman({ formikValues, formikErrors, formikTouched, setFieldValue }) {
   return (
      <>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <label htmlFor="serieCI">Serie CI</label>
               <CustomInput
                  id={"serieCI"}
                  name={"serieCI"}
                  type={"text"}
                  placeholder={"Serie CI"}
                  value={formikValues.serieCI}
                  error={formikErrors.serieCI}
                  touched={formikTouched.serieCI}
                  setFieldValue={setFieldValue}
                  preventNumbers={true}
                  maxLengthText={2}
               />
            </div>
            <div className="col-md-6">
               <label htmlFor="numarCI">Număr CI</label>
               <CustomInput
                  id={"numarCI"}
                  name={"numarCI"}
                  type={"text"}
                  placeholder={"Număr CI"}
                  value={formikValues.numarCI}
                  error={formikErrors.numarCI}
                  touched={formikTouched.numarCI}
                  setFieldValue={setFieldValue}
                  maxLengthNumber={6}
               />
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <label htmlFor="emisDeCI">Emis de</label>
               <CustomInput
                  id={"emisDeCI"}
                  name={"emisDeCI"}
                  type={"text"}
                  placeholder={"Emis de"}
                  value={formikValues.emisDeCI}
                  error={formikErrors.emisDeCI}
                  touched={formikTouched.emisDeCI}
                  setFieldValue={setFieldValue}
               />
            </div>
            <div className="col-md-6">
               <label htmlFor="emisLaCI">Emis la</label>
               <CustomInput
                  id={"emisLaCI"}
                  name={"emisLaCI"}
                  type={"text"}
                  placeholder={"Emis la"}
                  value={formikValues.emisLaCI}
                  error={formikErrors.emisLaCI}
                  touched={formikTouched.emisLaCI}
                  setFieldValue={setFieldValue}
                  maxLengthText={8}
                  preventLetters={true}
               />
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <label htmlFor="expiraLaCI">Expiră la</label>
               <CustomInput
                  id={"expiraLaCI"}
                  name={"expiraLaCI"}
                  type={"text"}
                  placeholder={"Expiră la"}
                  value={formikValues.expiraLaCI}
                  error={formikErrors.expiraLaCI}
                  touched={formikTouched.expiraLaCI}
                  setFieldValue={setFieldValue}
                  maxLengthText={8}
                  preventLetters={true}
               />
            </div>
            <div className="col-md-6">
               <label htmlFor="cnp">CNP</label>
               <CustomInput
                  id={"cnp"}
                  name={"cnp"}
                  type={"text"}
                  placeholder={"CNP"}
                  value={formikValues.cnp}
                  error={formikErrors.cnp}
                  touched={formikTouched.cnp}
                  setFieldValue={setFieldValue}
                  maxLengthNumber={13}
               />
            </div>
         </div>
      </>
   );
}
